// import React, { useEffect, useState } from "react";
// import { getUserProfilePhoto } from "../../services/authService-sighup";

interface AvatarProps {
  fullName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}
function getTextColor(bgColor: string): string {

  const hex = bgColor.replace("#", "");
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);


  const luminance = (0.299 * r + 0.587 * g + 0.114 * b);

  return luminance > 186 ? "#333" : "#fff";
}


function stringToColor(name: string): string {
  const pastelColors = [
    "#D9E8FC", // light blue
    "#FFE5EC", // light pink
    "#E2F0CB", // light green
    "#FFF5CC", // light yellow
    "#FDE2E2", // light red
    "#EADCFD", // light purple
    "#D0F4DE", // mint
    "#F9E79F", // warm yellow
    "#FCD5CE", // peach
    "#DEF3FD", // sky blue
  ];

  const hash = Array.from(name).reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
  const index = Math.abs(hash) % pastelColors.length;

  return pastelColors[index];
}


// let inMemoryAvatarUrl: string | null = null;

const Avatar: React.FC<AvatarProps> = ({
  fullName = "",
  size = 40,
  className = "",
  onClick,
}) => {
  // const [imageUrl, setImageUrl] = useState<string | null>(null);
  // const [hasImageError, setHasImageError] = useState(false);
  // const [isLoading, setIsLoading] = useState(true); 
  const bgColor = stringToColor(fullName || "default");
  const textColor = getTextColor(bgColor);
  
  // useEffect(() => {
  //   const loadAvatar = async () => {
  //     if (inMemoryAvatarUrl) {
  //       setImageUrl(inMemoryAvatarUrl);
  //       setIsLoading(false);
  //       return;
  //     }

  //     const cachedUrl = sessionStorage.getItem("userProfilePhotoUrl");
  //     if (cachedUrl) {
  //       preloadImage(cachedUrl);
  //       return;
  //     }

  //     try {
  //       const url = await getUserProfilePhoto();
  //       if (url) {
  //         sessionStorage.setItem("userProfilePhotoUrl", url);
  //         preloadImage(url);
  //       } else {
  //         setHasImageError(true);
  //         setIsLoading(false);
  //       }
  //     } catch {
  //       setHasImageError(true);
  //       setIsLoading(false);
  //     }
  //   };

  //   const preloadImage = (url: string) => {
  //     const img = new Image();
  //     img.src = url;
  //     img.onload = () => {
  //       inMemoryAvatarUrl = url;
  //       setImageUrl(url);
  //       setIsLoading(false);
  //     };
  //     img.onerror = () => {
  //       sessionStorage.removeItem("userProfilePhotoUrl");
  //       setHasImageError(true);
  //       setIsLoading(false);
  //     };
  //   };

  //   loadAvatar();
  // }, []);

  const getInitials = (name: string) => {
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  const initials = getInitials(fullName);

  
  // if (isLoading) return null;

  
  // if (imageUrl && !hasImageError) {
  //   return (
  //     <img
  //       src={imageUrl}
  //       alt={fullName}
  //       className={`rounded-full object-cover cursor-pointer transition-transform duration-300 hover:scale-110 ${className}`}
  //       style={{ width: size, height: size }}
  //       onClick={onClick}
  //     />
  //   );
  // }

  return (
    <div
    onClick={onClick}
    className={`flex items-center justify-center rounded-full font-medium cursor-pointer transition-transform duration-300 hover:scale-110 ${className}`}
    style={{
      width: size,
      height: size,
      fontSize: size / 2,
      backgroundColor: bgColor,
      color: textColor,
    }}
  >
    {initials}
  </div>
  
  
  );
  
};

export default Avatar;
